<ion-spinner *ngIf="loading"></ion-spinner>

<div class="question" *ngIf="!loading" [ngSwitch]="mode">
  <form [autocomplete]="false" (ngSubmit)="getCustomQuote()" #cqForm="ngForm" *ngSwitchDefault>
    <div class="amount">
      <ion-label>Choose your own amount of additional Life with Multi-Claim Cover</ion-label>
      <div class="input-group">
        <span class="pound"> &pound;</span>
        <input type="tel" class="form-control" [(ngModel)]="sumAssured" name="sumAssured" placeholder="Type amount" />
      </div>
    </div>
    <div class="invalid-feedback d-block" *ngIf="submitted && formError">{{formError}}</div>
    <div class="summary__buttons" buttons>
      <ion-button type="submit" [disabled]="cqForm.invalid" slot="end" tabindex="1">
        Calculate
      </ion-button>
    </div>
  </form>

  <div *ngSwitchCase="'display'">
    <ion-grid *ngIf="!loading && !error && customQuote">
      <ion-row class="custom-offer">
        <ion-col>
          <app-quote-option [quote]="customQuote" [premium]="customQuote.result.premium - quote.result.premium"
                            allowEdit="true" (select)="select.emit(customQuote)" (edit)="reset()">
          </app-quote-option>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>

</div>